<template>
	<div class="bigbox">
		<div id="departtu1" class="mapmain"></div>
	</div>
</template>
<script>
	// 1.引入echarts
	import * as echarts from 'echarts'

	export default {
		props: {
			Interfacedata: {}
		},
		data() {
			return {
				myChart: null,
				option: {
					title: {
						text: '北京市中医院知识产权转化金额趋势'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: ['转化金额', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '转化金额',
						type: 'line',
						stack: 'Total',
						areaStyle: {},
						emphasis: {
							focus: 'series'
						},
						data: [150, 232, 201, 154, 190, 330, 410]
					}, ]
				}
			}
		},
		watch: {
			// 接口数据
			Interfacedata: {
				handler(newName, oldName) {

				},
				deep: true
			}
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
				// 使用Echarts插件的时候，多次加载会出现There is a chart instance already initialized on the dom.这个错误，添加这个判断可以防止出现报错
				if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
					this.myChart.dispose();
				}
				// 基于准备好的dom，初始化echarts实例
				this.myChart = echarts.init(document.getElementById('departtu1'))
				this.myChart.setOption(this.option)
			}
		}
	}
</script>
<style scoped lang="less">
	.bigbox{
		width: 100%;
		height: 100%;
	}
	.mapmain {
		width: 90%;
		height: 95%;
		min-height: 70vh;
		min-width: 70vw;
		font-size: 16px;
		margin:  0 auto;
		// border: 1px solid black;
	}
</style>
